import React from 'react'
import { signIn } from '../../features/auth/authSlice'
import { useSignInForm } from '../../features/auth/useSignInForm'
import NeutralAuthLayout from '../../components/NeutralAuth/NeutralAuthLayout'
import NeutralSignInForm from '../../components/NeutralAuth/NeutralSignInForm'
import { CLIENT_PORTAL_LABEL } from '../../lib/portalAudience'
import { ChatIcon, DocumentIcon, ShieldLockIcon } from '../../components/NeutralAuth/icons'

const FEATURES = [
  { Icon: DocumentIcon, title: 'Track Progress', text: 'Stay updated on your case status in real time.' },
  { Icon: ChatIcon, title: 'Message Your Team', text: 'Securely communicate with your legal team.' },
  { Icon: ShieldLockIcon, title: 'Your Information, Secure', text: 'We keep your data private and protected.' },
]

const reload = () => window.location.reload(false)

const NeutralSignIn = () => {
  const form = useSignInForm({ thunk: signIn, defaultRedirect: reload })

  return (
    <NeutralAuthLayout
      brandLabel={CLIENT_PORTAL_LABEL}
      headline={['Your case,', 'your control.']}
      lede="Sign in to track your case progress and communicate with your legal team."
      features={FEATURES}
    >
      <NeutralSignInForm
        idPrefix="na-client"
        title="Client Access"
        subtitle="Sign in to your account"
        emailPlaceholder="yourname@email.com"
        forgotHref="/forgot-password"
        submitLabel="Access My Account"
        form={form}
      />
    </NeutralAuthLayout>
  )
}

export default NeutralSignIn
